import React from 'react';

const CitySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 21h4v-3h-4v3zM10 9.9l10 4.6V21h-2v-4h-6v4h-2V9.9zM4 3h8v6.7l-4.4-2-.4 1 1.8.8V21H4v-2h2v-1H4v-3h2v-1H4V3zM3 2v19H2v1h20v-1h-1v-6l1.5.7.5-.9-4-1.8v-3h-1v2.5l-5-2.3V2H3z"
        />
    </svg>
);

CitySvg.displayName = 'CitySvg';
export default CitySvg;
